/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const optionWithScoreDataSchema = z.object({
	escoSkills: z.array(z.object({ conceptUri: z.string(), preferredLabel: z.string(), confirmedByUser: z.boolean() }))
		.nullable(),
	scoreValue: z.number().nullable(),
	isDisqualifying: z.boolean().nullable().default(false),
	id: z.string().uuid(),
	label: z.string(),
	position: z.number(),
	consentType: z.string().nullable(),
	escoMappingReason: z.string().nullable(),
})

export type OptionWithScoreDataSchema = z.infer<typeof optionWithScoreDataSchema>
